import PropTypes from 'prop-types';
import { CloudinaryPicture, ArrowLink, EsgLogo } from '@bwoty-web/ui-kit';
import './excursionList.scss';

const getExcursionUrl = (siteId, masterId, isMobileApp, wvId) => {
  let queryParams = `masterId=${masterId}`;
  let detailPageSuffix = '';
  if (isMobileApp) {
    queryParams += '&consent=hide'; // disable showing cookie consent in app
    detailPageSuffix += '-app'; // route to app-specific detail page
  }
  if (wvId) {
    queryParams += `&resortWvId=${wvId}`; // disable showing cookie consent in app
  }

  switch (parseInt(siteId, 10)) {
    case 1:
      return `/utflykter/visa-utflykt${detailPageSuffix}?${queryParams}`;
    case 3:
      return `/utflukter/vis-utflukt${detailPageSuffix}?${queryParams}`;
    case 11:
      return `/udflugter/vis-udflugt${detailPageSuffix}?${queryParams}`;
    case 15:
      return `/retket/nayta-retki${detailPageSuffix}?${queryParams}`;
    default:
      return `/utflykter/visa-utflykt${detailPageSuffix}?${queryParams}`;
  }
};
const ExcursionList = ({
  excursions,
  readMoreLabel,
  siteId,
  isMobileApp,
  wvId,
}) => {
  return (
    <div className="gw-excursion-list">
      {excursions?.map((excursion) => {
        const {
          id,
          heading,
          description,
          imageCloudinaryUriTemplate,
          esgCertified,
        } = excursion;
        return (
          <div className="gw-excursion-list-item" key={id}>
            <div className="gw-excursion-list-item__image-container">
              {esgCertified && (
                <EsgLogo
                  esgType="square"
                  size={{
                    desktop: 28,
                    mobile: 24,
                  }}
                  className="gw-excursion-list-item__esg-logo"
                />
              )}
              <CloudinaryPicture
                className="gw-excursion-list-item__image"
                img={{ cloudinaryUriTemplate: imageCloudinaryUriTemplate }}
                alt={heading}
                sizes={[{ width: 274, height: 150 }]}
                lazy
                retina
              />
            </div>
            <div className="gw-excursion-list-item__content">
              <div className="gw-excursion-list-item__heading">{heading}</div>
              <div className="gw-excursion-list-item__description">
                {description}
              </div>
              <ArrowLink
                className="gw-excursion-list-item__read-more-link"
                href={getExcursionUrl(siteId, id, isMobileApp, wvId)}
              >
                {readMoreLabel}
              </ArrowLink>
            </div>
          </div>
        );
      })}
    </div>
  );
};

ExcursionList.propTypes = {
  excursions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string,
      description: PropTypes.string,
      heading: PropTypes.string,
      imageCloudinaryUriTemplate: PropTypes.string,
    }),
  ).isRequired,
  readMoreLabel: PropTypes.string,
  siteId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  isMobileApp: PropTypes.bool,
  wvId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

ExcursionList.defaultProps = {
  readMoreLabel: 'Read more',
  wvId: '',
  isMobileApp: false,
};

export default ExcursionList;
